// 5.50.0 the rows shared by the Today card (Main + HealthSherpa) and the red Today panel (Calendar page):
//   TodayItemRow — one of today's events / tasks (unchanged from the 5.34.0 panel: done-checkbox for a task, click to
//                  open in the Calendar, ⤢ Expand for notes, 📝 Form / 📂 Client for follow-ups)
//   ReminderRow  — a reminder that has come due: highlighted at the top with Dismiss and Open calendar (the 5.32.0
//                  pop-up's content and buttons)
import React from 'react';
import { formatRange } from './calendarTime';
import { itemWhen } from './calendarToday';
import { openClientInMain, openFormInAcord, formHref } from './calendarFollowup';
import { ExpandButton } from './NotesReader';

export const VIOLET = '#7c3aed';

export function TodayItemRow({ i, day, accent, sub = '#fecaca', busy, onComplete, onOpen, onExpand, onOpenClient }) {
  return (
    <div data-testid={i.kind === 'task' ? 'today-task' : 'today-event'} data-object-id={i.object_id}
      style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '7px 10px', borderBottom: `1px solid ${accent}55` }}>
      {i.kind === 'task' && (
        <input type="checkbox" checked={false} disabled={busy === i.object_id || !i.can_edit} onChange={() => onComplete(i)}
          aria-label={`Mark "${i.title}" done`} data-testid="today-task-check" style={{ marginTop: 3, width: 15, height: 15, cursor: 'pointer', accentColor: accent }} />
      )}
      <button type="button" onClick={() => onOpen(i)} data-testid="today-open"
        style={{ flex: 1, minWidth: 0, textAlign: 'left', background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: '#fff' }}>
        <div style={{ fontSize: 13, fontWeight: 600, wordBreak: 'break-word', color: '#fff' }}>
          {i.kind === 'task' ? '✔ ' : ''}{i.recurring ? '🔁 ' : ''}{i.title}
          {i.new && <span style={{ marginLeft: 6, fontSize: 10, background: '#fff', color: accent, borderRadius: 4, padding: '0 4px', fontWeight: 800 }}>NEW</span>}
        </div>
        <div style={{ fontSize: 12, color: sub }}>{itemWhen(i, day)}{i.location ? ` · 📍 ${i.location}` : ''}</div>
      </button>
      {(i.notes || '').trim() !== '' && (
        <ExpandButton dark onClick={() => onExpand(i)} testid="today-expand" />
      )}
      {formHref(i.form_type, i.form_id) && (    /* 5.42.0 follow-up from an ACORD form -> open the form in ACORD */
        <button type="button" onClick={() => openFormInAcord(i.form_type, i.form_id)}
          data-testid="today-open-form" title="Open this form in ACORD"
          style={{ flexShrink: 0, padding: '2px 7px', fontSize: 11, border: '1px solid #fff', borderRadius: 5, background: 'transparent', color: '#fff', cursor: 'pointer' }}>📝 Form</button>
      )}
      {i.client_id && (    /* 5.38.0 client follow-up -> open the client (in this window when it is Main) */
        <button type="button" onClick={() => (onOpenClient ? onOpenClient(i.client_id) : openClientInMain(i.client_id))}
          data-testid="today-open-client" title="Open this client's folder in InsureDocs"
          style={{ flexShrink: 0, padding: '2px 7px', fontSize: 11, border: '1px solid #fff', borderRadius: 5, background: 'transparent', color: '#fff', cursor: 'pointer' }}>📂 Client</button>
      )}
    </div>
  );
}

export function ReminderRow({ r, onDismiss, onOpenCalendar }) {
  return (
    <div role="alert" data-testid="cal-reminder" data-reminder-key={r.key}
      style={{ background: '#3b1d6e', borderLeft: `4px solid #c4b5fd`, padding: '8px 10px', borderBottom: `1px solid ${VIOLET}` }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#ddd6fe', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
        🔔 {r.kind === 'task' ? 'Task reminder' : 'Reminder'} · {r.calendar}
      </div>
      <div style={{ fontSize: 14, fontWeight: 700, marginTop: 3, wordBreak: 'break-word', color: '#fff' }} data-testid="cal-reminder-title">{r.title}</div>
      <div style={{ fontSize: 12, marginTop: 2, color: '#e9d5ff' }}>{formatRange(r.start, r.end, r.all_day)}</div>
      {r.location && <div style={{ fontSize: 12, marginTop: 2, color: '#d8b4fe' }}>📍 {r.location}</div>}
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <button type="button" onClick={() => onDismiss(r)} data-testid="cal-reminder-dismiss"
          style={{ padding: '4px 14px', background: VIOLET, color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>Dismiss</button>
        {onOpenCalendar && (
          <button type="button" onClick={() => onOpenCalendar(r)} data-testid="cal-reminder-open"
            style={{ padding: '4px 12px', background: 'transparent', color: '#e9d5ff', border: '1px solid #a78bfa', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Open calendar</button>
        )}
      </div>
    </div>
  );
}
